
  export default {
'button' : { 

 typeTheme :{ 
 'swtichAccount' : { 
  'line-height' : '30px'
 
}} 
}

}